import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-phone-number-verification-text',
    templateUrl: './phone-number-verification-text.component.html',
    standalone: false
})
export class PhoneNumberVerificationTextComponent implements OnInit {
  @Input() number: string = '';
  @Input() isVerified: boolean = false;
  /** Chi ha verificato il numero: il testo di conferma del paziente non ha senso per una clinica. */
  @Input() audience: 'patient' | 'clinic' = 'patient';

  constructor(
  ) { }

  ngOnInit() {
  }

  getMaskedNumber(number: string): string {
    if (!number) return '';
    const visible = number.slice(-3);
    const prefix = number.startsWith('+') ? '+' : '';
    const hiddenPart = 'x'.repeat(number.length - (prefix ? 4 : 3)); 
    return prefix + hiddenPart + visible;
  }  

}
